<template>
    <div class="h-full w-full bg-gray-100 ">
        <div v-if="canLoadCRMStatusSummary" class="w-full h-full">
            <div class="py-1.5 px-3 bg-white flex flex-col justify-center items-center border-r-2 z-20 border-b-2  border-gray-200 fixed" :class="width">
                <div v-if="isLoading" class="h-8 w-full animate-pulse rounded bg-gray-300"></div>
                <loading-button
                    v-else
                    :button-id="buttonId"
                    :button-reset-id="buttonResetId"
                    :clickData="{actionKey: 'setCRMSummaries', payload: fetchFilter}"
                    @button-click="performSummaryAction"
                    class="w-full h-8 px-2 tracking-wide font-medium"
                >
                    Load CRM Summary
                </loading-button>
            </div>
            <div class="h-[calc(100%-5rem)] p-3 overflow-y-scroll top-11 relative font-medium tracking-wide">
                <div v-if="isLoading" class="flex flex-col space-y-3">
                    <div class="pt-2 flex flex-col space-y-2">
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                    </div>
                    <div class="pt-2 flex flex-col space-y-2">
                        <div class="h-5 w-40 rounded bg-gray-300"></div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                    </div>
                    <div class="pt-2 flex flex-col space-y-2">
                        <div class="h-5 w-40 rounded bg-gray-300"></div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                        <div class="w-full flex space-x-1 pl-1">
                            <div class="h-5 w-4 rounded bg-gray-300"></div>
                            <div class="h-5 w-full rounded bg-gray-300"></div>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col space-y-3" v-else-if="summaryActions && (summaryActions.setCRMSummaries.crmSummaryStages || summaryActions.setCRMSummaries.crmStatuses || summaryActions.setCRMSummaries.crmActions)">
                    <div>
                        <div class="whitespace-pre-wrap">{{ ` -${summaryActions.setCRMSummaries.crmSummaryStages ? summaryActions.setCRMSummaries.crmSummaryStages.replaceAll(' | ', '\n - ').slice(0, -3) : ''}` }}</div>
                    </div>
                    <div>
                        <div class="whitespace-pre-wrap">{{ summaryActions.setCRMSummaries.crmStatuses ? summaryActions.setCRMSummaries.crmStatuses.replaceAll(' -- ', '\n - ').slice(0, -3) : '' }}</div>
                    </div>
                    <div>
                        <div  class="whitespace-pre-wrap">{{ summaryActions.setCRMSummaries.crmActions ? summaryActions.setCRMSummaries.crmActions.replaceAll(' -- ', '\n - ').slice(0, -3) : '' }}</div>
                    </div>

                </div>
            </div>
        </div>
        <div v-else class="flex flex-col items-center space-y-1 tracking-wide font-medium p-3">
            <div>Cannot load summary data:</div>
            <div>Results exceed 3000-row limit.</div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue';
import LoadingButton from './LoadingButton.vue';

const props = defineProps(['summaryActions', 'isLoading', 'resultCount', 'fetchFilter' , 'width', 'buttonResetId'])
const emit = defineEmits(['perform-summary-action'])

const canLoadCRMStatusSummary = ref(false)

const buttonId = ref(props.summaryActions && props.summaryActions.setCRMSummaries ? props.summaryActions.setCRMSummaries.buttonId : null)

watch(() => props.resultCount, () => {
    allowCRMStatusByResultCount(props.resultCount)
})

function allowCRMStatusByResultCount (resultCount) {
    if(resultCount < 3000) {
        canLoadCRMStatusSummary.value = true
    } else {
        canLoadCRMStatusSummary.value = false
    }
}

allowCRMStatusByResultCount(props.resultCount)

function performSummaryAction(actionData) {
    // console.log('performSummaryAction')
    emit('perform-summary-action', actionData)
}
</script>